export default __webpack_public_path__ + "static/media/day1day2.835924a0.png";